// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".care-team-member-cc .ui-icon{vertical-align:text-top !important}.care-coordinator:hover .edit-modal__hidden-icon,.care-coordinator:hover .edit-modal__hidden-text{visibility:visible}@media only screen and (max-width: 1250px)and (min-width: 768px){.care-team-members__delete-btn span,.care-team-members__edit-btn span{display:none}}", ""]);
// Exports
module.exports = exports;
